import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1220 - Reverse Convertible - No Barrier
 * Autocall
 */
export const config1220Autocall: ProductTypeConfig = {
  code: '1220',
  callableType: 'Autocall',
  name: 'Reverse Convertible - No Barrier',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        issuePricePct: false,
        settlementType: true,
      },
    },
    // Configuración para Barrier: eliminar todos los campos relacionados con barrera
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.barrier.props,
        barrierType: true, // Mostrar "Barrier type"
        strikeLevel: true, // Mostrar "Strike level"
        strikeDistance: true, // Mostrar "Strike distance (worst-off)"
        barrierLevel: false, // Ocultar "Barrier"
        barrierDistance: false, // Ocultar "Distance From Barrier"
        barrierHit: false, // Ocultar "Barrier hit"
      },
    },
    // Configuración para Underlyings: ocultar campos de barrera
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false, // Ocultar "Barrier Level"
        barrierDistance: false, // Ocultar "Barrier distance"
        autocallDistance: true, // Mostrar "Distance from autocall"
      },
    },
    // Configuración para Early Redemption
    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: true, // Autocall shows redemption level %
        showIssuerCallable: false,
      },
    },
  },
};

/**
 * 1220 - Reverse Convertible - No Barrier
 * Callable
 */
export const config1220Callable: ProductTypeConfig = {
  code: '1220',
  callableType: 'Callable',
  name: 'Reverse Convertible - No Barrier',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        issuePricePct: false,
        settlementType: true,
      },
    },
    // Configuración para Barrier: eliminar todos los campos relacionados con barrera
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.barrier.props,
        barrierType: true, // Mostrar "Barrier type"
        strikeLevel: true, // Mostrar "Strike level"
        strikeDistance: true, // Mostrar "Strike distance (worst-off)"
        barrierLevel: false, // Ocultar "Barrier"
        barrierDistance: false, // Ocultar "Distance From Barrier"
        barrierHit: false, // Ocultar "Barrier hit"
      },
    },
    // Configuración para Underlyings: ocultar campos de barrera
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false, // Ocultar "Barrier Level"
        barrierDistance: false, // Ocultar "Barrier distance"
      },
    },
    // Configuración para Early Redemption
    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: false, // Callable doesn't show % level
        showIssuerCallable: true, // Shows "Issuer Callable" text
      },
    },
  },
};

/**
 * 1220 - Reverse Convertible - No Barrier
 * Standard
 */
export const config1220Standard: ProductTypeConfig = {
  code: '1220',
  callableType: 'Standard',
  name: 'Reverse Convertible - No Barrier',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        issuePricePct: false,
        settlementType: true,
      },
    },
    // Configuración para Barrier: eliminar todos los campos relacionados con barrera
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        ...DEFAULT_SECTIONS.barrier.props,
        barrierType: true, // Mostrar "Barrier type"
        strikeLevel: true, // Mostrar "Strike level"
        strikeDistance: true, // Mostrar "Strike distance (worst-off)"
        barrierLevel: false, // Ocultar "Barrier"
        barrierDistance: false, // Ocultar "Distance From Barrier"
        barrierHit: false, // Ocultar "Barrier hit"
      },
    },
    // Configuración para Underlyings: ocultar campos de barrera
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false, // Ocultar "Barrier Level"
        barrierDistance: false, // Ocultar "Barrier distance"
      },
    },
    // Configuración para Early Redemption - Standard NO tiene
    earlyRedemption: {
      enabled: false,
      props: {},
    },
  },
};
